import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { Controller } from "react-hook-form"
import { withTranslation } from 'react-i18next'
import { FormControlLabel, Radio, RadioGroup } from '@mui/material'

export default withTranslation()(function RadioBtn ({options, name}) {
  // const { name, label } = props

  const { control, watch, trigger } = useFormContext()
  let v = watch(name)

  useEffect(() => {
    if (v) trigger(name)
  }, [v, trigger, name])


  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
        <RadioGroup aria-label="quiz" name={name} value={value ?? ''} onChange={onChange}>
          
          <div className="grid grid-cols-2 w-full">
            {
              options.map(({label, value}) => {
                return <FormControlLabel value={value} key={label} control={<Radio color="primary" />} label={label} />
              })
            }
          </div>
        </RadioGroup>
      )}
    />
  )
})